import { combineReducers } from 'redux';
import simpleReducer from './simpleReducer';
import cmsReducer from './cms_reducer/cms_reducer';

export default combineReducers({
    simpleReducer,cmsReducer
});